import React, { Component } from "react";
import SevenConfirmations from "./portfolio/7Confirmations";
import Logos from "./portfolio/Logos";
import MoviStack from "./portfolio/MoviStack";
import PortfolioSectionWrapper from "./portfolio/PortfolioSectionWrapper";
import Surveyed from "./portfolio/Surveyed";
import Zypher from "./portfolio/Zypher";

export default class Porfolio extends Component {
  render() {
    return (
      <section id="portfolio">
        <div className="row">
          <div className="twelve columns collapsed">
            <div
              id="portfolio-wrapper"
              className="bgrid-quarters s-bgrid-thirds cf"
            >
              <PortfolioSectionWrapper
                heading="7C"
                headingColor="#f00071eb"
              >
                <SevenConfirmations />
              </PortfolioSectionWrapper>
              <PortfolioSectionWrapper
                heading="MoviStack"
                headingColor="#00f057eb"
              >
                <MoviStack />
              </PortfolioSectionWrapper>
              <PortfolioSectionWrapper
                heading="Surveyed"
                headingColor="#c700f0eb"
              >
                <Surveyed />
              </PortfolioSectionWrapper>
              <PortfolioSectionWrapper
                heading="Zypher"
                headingColor="#00f0b7eb"
              >
                <Zypher />
              </PortfolioSectionWrapper>
              <PortfolioSectionWrapper
                heading="Logo Designing"
                headingColor="#f00071eb"
              >
                <Logos />
              </PortfolioSectionWrapper>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
